// extracted by mini-css-extract-plugin
module.exports = {"trees":"Sources_trees__3QOQT","researchSectionFadeIn":"Sources_researchSectionFadeIn__1vIeW","nextPage":"Sources_nextPage__2wzgK"};